import { useLang } from "@/contexts/LanguageContext";

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  return (
    <div
      className="inline-flex items-center rounded-sm border border-[#E8E6E1] bg-white overflow-hidden"
      data-testid="language-switcher"
    >
      <button
        type="button"
        onClick={() => setLang("es")}
        className={`px-3 py-1.5 text-xs tracking-[0.2em] uppercase transition-all ${
          lang === "es" ? "bg-[#2563EB] text-[#F9F8F6]" : "text-[#5C5B5A] hover:text-[#1A1A1A]"
        }`}
        data-testid="lang-es-btn"
      >
        ES
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 text-xs tracking-[0.2em] uppercase transition-all ${
          lang === "en" ? "bg-[#2563EB] text-[#F9F8F6]" : "text-[#5C5B5A] hover:text-[#1A1A1A]"
        }`}
        data-testid="lang-en-btn"
      >
        EN
      </button>
    </div>
  );
}
